import store from "../../store/index";
const heatLayers = {
    heatmapLayer(blurRadius, features, field) {
        //热力图渲染器
        var heatmapRenderer = this.setRenderer(blurRadius, field);
        // new store.state.esriModule.HeatmapRenderer({
        //     colorStops: [{
        //             ratio: 0.45,
        //             color: "rgba(000,000,255,0)"
        //         },
        //         {
        //             ratio: 0.55,
        //             color: "rgb(000,255,255)"
        //         },
        //         {
        //             ratio: 0.65,
        //             color: "rgb(000,255,000)"
        //         },
        //         {
        //             ratio: 0.95,
        //             color: "rgb(255,255,000)"
        //         },
        //         {
        //             ratio: 1.00,
        //             color: "rgb(255,000,000)"
        //         },
        //     ],
        //     blurRadius: blurRadius,
        //     maxPixelIntensity: 10,
        //     minPixelIntensity: 1,
        //     field: field
        // });
        var layerDefinition = {
            "geometryType": "esriGeometryPoint",
            "fields": [{
                name: "ObjectID",
                type: "esriFieldTypeOID",
                alias: "ObjectID"
            }]
        };
        var featureCollection = {
            layerDefinition: layerDefinition,
            featureSet: null, //features
        };
        //创建 FeatureLayer 图层
        var featureLayer = new store.state.esriModule.FeatureLayer(featureCollection, {
            mode: store.state.esriModule.FeatureLayer.MODE_SNAPSHOT,
            outFields: ["*"],
            opacity: .8
        });
        //设置渲染方式
        featureLayer.setRenderer(heatmapRenderer);
        return featureLayer;
    },
    setRenderer(blurRadius, field) {
        var heatmapRenderer = new store.state.esriModule.HeatmapRenderer({
            colorStops: [{
                    ratio: 0.45,
                    color: "rgba(000,000,255,0)"
                },
                {
                    ratio: 0.55,
                    color: "rgb(000,255,255)"
                },
                {
                    ratio: 0.65,
                    color: "rgb(000,255,000)"
                },
                {
                    ratio: 0.95,
                    color: "rgb(255,255,000)"
                },
                {
                    ratio: 1.00,
                    color: "rgb(255,000,000)"
                },
            ],
            blurRadius: blurRadius,
            maxPixelIntensity: 10,
            minPixelIntensity: 1,
            field: field
        });
        return heatmapRenderer;
    }
}
export default heatLayers
